<section class="container admin-shell" [ngClass]="'theme-' + currentTheme()">
    <header class="admin-hero">
      <div>
        <p class="eyebrow">Store Console</p>
        <h2 style="margin:6px 0 4px">Admin</h2>
      </div>
      <div class="admin-badge">พร้อมใช้งาน ✅</div>
    </header>

    <div class="panel admin-card theme-panel">
      <div class="panel-header">
        <div>
          <p class="eyebrow">โหมดการแสดงผล</p>
          <h3 style="margin:4px 0">ปรับธีมหน้าผู้ดูแล</h3>
          <p class="small muted">เลือก 1 ใน 4 ธีมทันสมัย เพื่อให้เข้ากับร้านของคุณ</p>
        </div>
        <div class="pill">{{ getCurrentThemeName() }}</div>
      </div>
      <div class="theme-grid">
        <button
          class="theme-card"
          type="button"
          *ngFor="let theme of themes"
          [class.active]="theme.id === currentTheme()"
          (click)="setTheme(theme.id)">
          <span class="theme-thumb" [style.background-image]="theme.preview"></span>
          <div class="theme-card__body">
            <div class="theme-name">{{ theme.name }}</div>
            <p class="small muted">{{ theme.description }}</p>
          </div>
          <span class="theme-check" aria-hidden="true">✓</span>
        </button>
      </div>
    </div>

    <div class="panel admin-card">
      <div class="panel-header">
        <div>
          <p class="eyebrow">การแบ่งหน้า</p>
          <h3 style="margin:4px 0">จำนวนสินค้าต่อหน้า</h3>
          <p class="small muted">ตั้งค่าจำนวนสินค้าในหน้าร้าน (เหมือนการเลือกธีม)</p>
        </div>
        <div class="pill">{{ ps.pageSize() }} รายการ/หน้า</div>
      </div>
      <div class="pagination-grid">
        <button
          type="button"
          class="pagination-card"
          *ngFor="let size of [6,9,12]"
          [class.active]="ps.pageSize() === size"
          (click)="ps.setPageSize(size)">
          <div class="pagination-number">{{ size }}</div>
          <div class="small muted">สินค้าต่อหน้า</div>
          <span class="pagination-check" aria-hidden="true">✓</span>
        </button>
      </div>
    </div>

    <div class="admin-grid">
      <div class="panel admin-card">
        <div class="panel-header">
          <div>
            <p class="eyebrow">จัดการหมวดหมู่</p>
            <h3 style="margin:4px 0">แก้ไข/เพิ่มหมวดหมู่ที่จะใช้ในร้าน</h3>
          </div>
          <div class="pill pill-ghost">หมวดหมู่ {{ ps.categories().length }} รายการ</div>
        </div>
        <div class="category-add-row">
          <input class="input" [(ngModel)]="catInput" placeholder="เพิ่มหมวดหมู่ใหม่ เช่น กุ้ง / ปลา">
          <button class="btn primary" type="button" (click)="addCategory()">เพิ่ม</button>
        </div>
        <div class="category-list" *ngIf="ps.categories().length; else noCategories">
          <div class="category-row" *ngFor="let cat of ps.categories(); trackBy: trackCat">
            <input class="input" [ngModel]="catEdit[cat] ?? cat" (ngModelChange)="editCategory(cat, $event)">
            <div class="category-row__actions">
              <button class="btn" type="button" (click)="saveCategory(cat)">บันทึก</button>
              <button class="btn danger ghost" type="button" (click)="removeCategory(cat)">ลบ</button>
            </div>
          </div>
        </div>
        <ng-template #noCategories>
          <div class="muted">ยังไม่มีหมวดหมู่ โปรดเพิ่มอย่างน้อย 1 รายการ</div>
        </ng-template>
      </div>

      <div class="panel admin-card">
        <div class="panel-header">
          <div>
            <p class="eyebrow">การจัดการร้าน</p>
            <h3 style="margin:4px 0">เพิ่ม / อัปเดตสินค้า</h3>
          </div>
          <div class="pill-row">
            <span class="pill">สินค้า {{ ps.products().length }} รายการ</span>
            <span class="pill pill-ghost">เข้าสู่ระบบแล้ว</span>
          </div>
        </div>
        <div class="admin-toolbar">
          <button class="btn" (click)="logout()">Logout</button>
          <button class="btn danger" (click)="reset()">Reset ข้อมูลเริ่มต้น</button>
          <button class="btn" (click)="exportCsv()">Export เป็น Excel/CSV</button>
          <label class="btn ghost file-btn">
            <span *ngIf="!importing()">Import Excel/CSV</span>
            <span *ngIf="importing()">กำลังนำเข้า...</span>
            <input type="file" accept=".csv,text/csv" (change)="importCsv($event)" [disabled]="importing()">
          </label>
          <button class="btn danger ghost" (click)="clearAllProducts()">ลบสินค้าทั้งหมด</button>
          <div class="toolbar-status" [class.toolbar-status--dirty]="ps.pendingChanges()">
            <span class="dot"></span>
            <span class="label" *ngIf="ps.pendingChanges(); else cleanState">กำลังบันทึกอัตโนมัติ...</span>
            <ng-template #cleanState><span class="label">ข้อมูลเผยแพร่ล่าสุดแล้ว</span></ng-template>
          </div>
        </div>
        <p class="small muted">* ส่งออกเป็นไฟล์ CSV (รองรับการเปิดใน Excel) และนำเข้าด้วยไฟล์เดียวกัน รายการเดิมจะถูกแทนที่ให้เหมือนในไฟล์</p>

        <div class="form-grid two-col">
          <div><label class="small">ชื่อสินค้า</label><input class="input" [(ngModel)]="draft.name" placeholder="เช่น กุ้งสด 1 กก."></div>
          <div><label class="small">ราคา (บาท)</label><input class="input" type="number" [(ngModel)]="draft.price" placeholder="0"></div>
          <div><label class="small">หน่วย</label><input class="input" [(ngModel)]="draft.unit" placeholder="แพ็ค / กก. / ชิ้น"></div>
          <div>
            <label class="small">หมวดหมู่</label>
            <input class="input" [(ngModel)]="draft.category" placeholder="กุ้ง / ปลา / ซอส" list="category-options">
            <datalist id="category-options">
              <option *ngFor="let c of ps.categories()" [value]="c"></option>
            </datalist>
          </div>
          <div><label class="small">SKU</label><input class="input" [(ngModel)]="draft.sku" placeholder="ใส่หรือเว้นว่าง"></div>
          <div class="full-row"><label class="small">รายละเอียด</label><textarea class="input" rows="3" [(ngModel)]="draft.description" placeholder="จุดเด่น หรือวิธีใช้คร่าวๆ"></textarea></div>
          <div class="full-row upload-row">
            <div>
              <label class="small">รูปสินค้า (อัปโหลดได้หลายไฟล์)</label>
              <input type="file" accept="image/*" multiple (change)="onUploadNew($event)">
              <p class="small muted" style="margin-top:4px">บันทึกเป็น Data URL ในเครื่อง ไม่พึ่งลิงก์ภายนอก • เลือกหลายรูปได้พร้อมกัน</p>
            </div>
            <div class="image-chip" *ngIf="draft.images?.length">{{ draft.images.length }} รูป</div>
          </div>
        </div>
        <div *ngIf="draft.images?.length" class="preview-grid">
          <div class="preview-tile" *ngFor="let img of draft.images; let i = index">
            <img class="preview" [src]="img" alt="">
            <button class="btn tiny" type="button" (click)="removeDraftImage(i)">ลบ</button>
          </div>
        </div>
        <div class="action-row action-row--balanced">
          <button class="btn primary" type="button" (click)="add()">เพิ่มสินค้า</button>
          <button class="btn ghost" type="button" (click)="clearDraft()">ล้างฟอร์ม</button>
        </div>
      </div>

      <div class="panel admin-card">
        <div class="panel-header">
          <div>
            <p class="eyebrow">รายการสินค้า</p>
            <h3 style="margin:4px 0">แก้ไขได้ทันที</h3>
          </div>
          <div class="pill pill-ghost">แก้ไขแล้วบันทึกอัตโนมัติ</div>
        </div>
        <div class="table-wrap admin-table-wrap">
          <table class="table admin-table">
            <thead><tr><th style="width:104px">รูป</th><th>ชื่อ</th><th style="width:64px">ราคา</th><th style="width:138px">หน่วย/หมวด</th><th style="width:68px">SKU</th><th>รายละเอียด</th><th style="width:170px">จัดการ</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of ps.products(); trackBy: track">
                <td class="cell image-cell" data-label="รูป">
                  <div class="preview-frame preview-frame--row">
                    <img class="preview" [src]="p.image" alt="">
                  </div>
                  <div class="small muted" *ngIf="p.images?.length && p.images.length > 1">{{ p.images.length }} รูป</div>
                </td>
                <td class="cell" data-label="ชื่อ"><textarea class="input" rows="3" [(ngModel)]="p.name"></textarea></td>
                <td class="cell price-cell"  data-label="ราคา"><input class="input" type="number" [(ngModel)]="p.price"></td>
                <td class="cell stack-cell" data-label="หน่วย/หมวด">
                  <div class="stack-cell__inputs">
                    <input class="input" [(ngModel)]="p.unit">
                    <input class="input" [(ngModel)]="p.category" list="category-options">
                  </div>
                </td>
                <td class="cell sku-cell" data-label="SKU"><input class="input" [(ngModel)]="p.sku"></td>
                <td class="cell" data-label="รายละเอียด"><textarea class="input" rows="3" [(ngModel)]="p.description"></textarea></td>
                <td class="cell tr-actions admin-row-actions" data-label="จัดการ">
                  <div class="action-grid">
                    <label class="pill-btn ghost" title="เปลี่ยนรูป" aria-label="เปลี่ยนรูป">
                      <span class="glyph" aria-hidden="true">📁</span>
                      <span class="label">รูป</span>
                      <input type="file" accept="image/*" (change)="onReplaceImage(p, $event)">
                    </label>
                    <label class="pill-btn ghost" title="เพิ่มรูป" aria-label="เพิ่มรูป">
                      <span class="glyph" aria-hidden="true">➕</span>
                      <span class="label">เพิ่ม</span>
                      <input type="file" accept="image/*" multiple (change)="onAddImages(p, $event)">
                    </label>
                    <button class="pill-btn success" title="บันทึก" aria-label="บันทึก" (click)="save(p)">
                      <span class="glyph" aria-hidden="true">💾</span>
                      <span class="label">บันทึก</span>
                    </button>
                    <button class="pill-btn ghost" title="ยกเลิก" aria-label="ยกเลิก" (click)="cancelEdits()">
                      <span class="glyph" aria-hidden="true">↩</span>
                      <span class="label">ยกเลิก</span>
                    </button>
                    <button class="pill-btn danger" title="ลบ" aria-label="ลบ" (click)="remove(p.id)">
                      <span class="glyph" aria-hidden="true">🗑</span>
                      <span class="label">ลบ</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
